import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import CustomerDueDashBoard from "./customer-dashboard";
import Details from "../pages/inspectionDetails";
import EditInspection from "../pages/editInspection";
import InspectionPage from "../inspection/inspetionsPage";
import InspectionDetail from "../inspection/inspectionDetails";
import InspectionList from "../inspection/inspectionList";

class CustomerDasboard extends Component {
  render() {
    let { history } = this.props;
    return (
      <Switch>
        <Route
          exact
          path="/inspection"
          history={history}
          component={CustomerDueDashBoard}
        />
        <Route
          exact
          path="/inspection/details/:id"
          history={history}
          component={Details}
        />
        <Route
          exact
          path="/inspection/edit/:id"
          history={history}
          component={EditInspection}
        />
        <Route
          exact
          path="/inspection/new/:type"
          history={history}
          component={InspectionPage}
        />
        <Route
          exact
          path="/inspection/new/details/:id"
          history={history}
          component={InspectionDetail}
        />
        {/* InspectionList */}
        {/* <Route
                exact
                path="/inspection/edit/:id"
                history={history}
                component={EditInspection}
            /> */}
        <Route
          exact
          path="/inspection/new/start/inspection/:id/:type"
          history={history}
          component={InspectionList}
        />
      </Switch>
    );
  }
}

export default CustomerDasboard;



// WEBPACK FOOTER //
// ./src/customers/customerboardroutes.jsx